<template>
  <div class="min-h-screen bg-gray-950 dark:bg-gray-950 relative">
    <!-- 顶部渐变亮光效果 - 固定在顶部，添加pointer-events-none确保不会阻挡点击事件 -->
    <div
      class="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-purple-500/20 to-transparent z-5 pointer-events-none"
    ></div>

    <!-- 全局移动端导航 -->
    <MobileHeader />
    <AppNavigation />
    <!-- 渲染优先级：优先渲染主要内容 -->
    <main
      :class="['lg:ml-[250px] relative z-10', 'transition-all duration-300']"
    >
      <!-- 移动端顶部间距，防止内容被导航栏遮挡 -->
      <div class="h-16 lg:h-0 block"></div>

      <div
        class="mx-auto relative lg:pt-8 p-4 z-10 box-border overflow-auto"
        :class="{
          'h-[calc(100dvh_-_4rem)] lg:h-screen pb-24 lg:pb-32': showMusicPlayer,
          'h-[calc(100dvh_-_4rem)] lg:h-screen pb-4': !showMusicPlayer,
        }"
        style="-webkit-overflow-scrolling: touch"
      >
        <!-- 新用户欢迎横幅 - 移到滚动区域内部 -->
        <WelcomeBanner />

        <slot />
      </div>

      <!-- 懒加载音乐播放器 -->
      <MusicPlayer />

    </main>

    <!-- 按需加载次要UI元素 -->
    <GlobalToast />

  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";

// 音乐播放器显示状态
const showMusicPlayer = ref(false);

// 监听音乐播放器显示状态变化
const handlePlayerVisibilityChange = (event) => {
  showMusicPlayer.value = event.detail.isVisible;
};

onMounted(() => {
  // 添加自定义事件监听
  window.addEventListener(
    "music-player-visibility-change",
    handlePlayerVisibilityChange
  );
});

onUnmounted(() => {
  // 移除事件监听，防止内存泄漏
  window.removeEventListener(
    "music-player-visibility-change",
    handlePlayerVisibilityChange
  );
});
</script>

<style scoped>
.container {
  max-width: 1200px;
}

/* 优化关键渲染路径的CSS */
main {
  contain: content;
  content-visibility: auto;
}
</style>
